<template>
  <SubDeviceDetail :is-edit="false"/>
</template>

<script>
import SubDeviceDetail from './detail';

export default {
  name: "SubDeviceCreate",
  components: { SubDeviceDetail },
}
</script>

<style scoped>

</style>
